<div class="reporting-data-table">
  <table cellspacing="0">
    <ng-container *ngIf="data.length > 0; else noData">
      <thead>
        <tr>
          <ng-container *ngFor="let column of columns">
            <th>
              {{ column.label | translate }} <span *ngIf="column.key === 'amount'">({{ currency }})</span>
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dataItem of data | slice: 0:sliceItem">
          <td *ngFor="let item of dataItem | keyvalue: returnZero">
            {{ item.key !== 'type' ? item.value : (item.value | translate) }}
          </td>
        </tr>
      </tbody>
    </ng-container>
    <ng-template #noData>
      <tbody>
        <tr>
          <p>
            {{ 'performance.table.no_transactions' | translate }}
          </p>
        </tr>
      </tbody>
    </ng-template>
  </table>
</div>
